import { render } from "./CombinedLayout.vue?vue&type=template&id=6455821e&scoped=true"
import script from "./CombinedLayout.vue?vue&type=script&lang=js"
export * from "./CombinedLayout.vue?vue&type=script&lang=js"

import "./CombinedLayout.vue?vue&type=style&index=0&id=6455821e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6455821e"]])

export default __exports__
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnToggle,QToggle,QCheckbox,QBtnGroup,QBtn});
